<template>
  <validation-observer ref="simpleRules">
    <donation-groups />
    <bank-accounts />
    <donate-date />
    <amount />
    <notes />
    <b-button
      variant="primary"
      :disabled="submitStatus || (dataItem.amount > dataItem.former_amount)"
      @click="submitForm"
    >
      <FeatherIcon icon="SaveIcon" />
      Transferi Kaydet
    </b-button>
  </validation-observer>
</template>
<script>
import BankAccounts from '@/views/Admin/Account_activities/Components/TransferModal/elements/BankAccounts.vue'
import DonateDate from '@/views/Admin/Account_activities/Components/TransferModal/elements/DonateDate.vue'
import DonationGroups from '@/views/Admin/Account_activities/Components/TransferModal/elements/DonationGroups.vue'
import Amount from '@/views/Admin/Account_activities/Components/TransferModal/elements/Amount.vue'
import Notes from '@/views/Admin/Account_activities/Components/TransferModal/elements/Notes.vue'
import { BButton } from 'bootstrap-vue'
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import toastMixin from '@/libs/toast'

export default {
  name: 'TransferForm',
  components: {
    ValidationObserver,
    BankAccounts,
    DonateDate,
    DonationGroups,
    Amount,
    Notes,
    BButton,
  },
  mixins: [toastMixin],
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/transferDataItem']
    },
    transferModal() {
      return this.$store.getters['accountActivities/transferModal']
    },
    saveData() {
      return this.$store.getters['accountActivities/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({ template: 'saveSuccess' })
        this.transferModal.status = false
      } else if (val.status === false) {
        this.showToast({ template: 'saveError' })
      }
    },
  },
  created() {
    this.submitStatus = false
    localize('tr')
  },
  methods: {
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          this.$store.dispatch('accountActivities/transferData', this.dataItem)
        } else {
          this.showToast({ template: 'requireWarning' })
        }
      })
    },
  },
}
</script>
